import { checkIsLegacyPostfix } from '../helpers';

export const removeLegacyPostfix = (string: string) => {
  if (checkIsLegacyPostfix(string)) {
    return string.replace('-en', '');
  }

  return string;
};

export default removeLegacyPostfix;
